module.exports = __webpack_public_path__ + "img/equalitate.f13be0d9.png";